import { CSSProperties } from "react";

export const XInfluentPointSvg = ({
  width,
  style,
}: {
  width: number;
  style?: CSSProperties;
}) => {
  return (
    <svg
      style={style}
      width={width}
      height={width}
      viewBox="0 0 68 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_i_219_438)">
        <path
          d="M66.0797 30.4169L36.3233 1.71636C34.758 0.206567 32.2732 0.224064 30.7293 1.75574L1.80034 30.4554C0.247481 31.996 0.220083 34.4982 1.73884 36.0724L30.6687 66.058C32.2262 67.6724 34.8065 67.6905 36.3866 66.0983L66.1421 36.1135C67.7139 34.5296 67.6858 31.966 66.0797 30.4169Z"
          fill="url(#paint0_linear_219_438)"
        />
      </g>
      <defs>
        <filter
          id="filter0_i_219_438"
          x="0.617493"
          y="0.595398"
          width="66.6853"
          height="66.6853"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_219_438"
          />
        </filter>
        <linearGradient
          id="paint0_linear_219_438"
          x1="34"
          y1="-1"
          x2="34"
          y2="69"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.09375" stopColor="#7FB0D5" />
          <stop offset="0.5" stopColor="#336A92" />
          <stop offset="0.895833" stopColor="#508CB7" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </svg>
  );
};
